import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import IconSpinner from '../../img/spinner.gif';
import Blanket from './Blanket';

const ProgressWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 2px;
  /* display: flex; */
  border: 1px solid #b1b6bb;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);
  /* padding: 1rem; */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 322px;
  height: 156px;
  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 280px;
      height: 156px;
    `}
`;

const DocOpenProgressImg = styled.img`
  width: 64px;
  height: 64px;
`;

const PopupMessage = styled.span`
  margin-top: 11px;
  font-size: 14px;
  text-align: center;
  color: #2f3133;
`;

export default function ProgressPopup({ message, isMobile }) {
  const { t } = useTranslation();
  return (
    <>
      <Blanket />
      <ProgressWrapper isMobile={isMobile}>
        <DocOpenProgressImg src={IconSpinner} isMobile={isMobile} />
        <PopupMessage>{message}</PopupMessage>
      </ProgressWrapper>
    </>
  );
}
